function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M438.851,194.691v159.652c-7.92-3.17-16.556-4.935-25.605-4.935c-38.059,0-68.912,30.854-68.912,68.912 s30.854,68.911,68.912,68.911s68.912-30.854,68.912-68.911c0-0.021,0-0.038,0-0.058l0,0V194.691v-86.613h-43.307H264.222 c0.562,5.025,0.879,10.121,0.879,15.295c0,26.118-7.379,50.544-20.139,71.318H438.851z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.511,226.886c-12.645,10.894-27.283,19.524-43.306,25.236v102.224c-7.92-3.172-16.554-4.936-25.605-4.936 c-38.059,0-68.912,30.854-68.912,68.912c0,38.058,30.853,68.911,68.912,68.911s68.912-30.854,68.912-68.911 c0-0.021,0-0.038,0-0.057l0,0L217.511,226.886L217.511,226.886z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.449,246.746c16.172,0,31.603-3.145,45.756-8.801c16.493-6.592,31.22-16.636,43.306-29.247 c4.191-4.374,8.061-9.054,11.578-14.007c14.299-20.139,22.733-44.738,22.733-71.318c0-5.182-0.355-10.278-0.979-15.295 C243.308,47.163,191.404,0,128.449,0C60.312,0,5.076,55.237,5.076,123.373C5.076,191.51,60.31,246.746,128.449,246.746z  M51.744,95.287h48.616V46.669h56.172v48.616h48.618v12.793v43.378h-30.946h-17.67v48.618h-56.172v-48.616H51.744V95.287z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgAddToPlaylist = function SvgAddToPlaylist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "487.234px",
    height: "487.233px",
    viewBox: "0 0 487.234 487.233",
    style: {
      enableBackground: "new 0 0 487.234 487.233"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddToPlaylist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-to-playlist.41abde7b.svg";
export { ForwardRef as ReactComponent };